export default "__VITE_ASSET__CB$AmEdw__"